import { render, staticRenderFns } from "./WizardTeamsStep.vue?vue&type=template&id=593562cd&"
import script from "./WizardTeamsStep.vue?vue&type=script&lang=js&"
export * from "./WizardTeamsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports